export default __webpack_public_path__ + "static/media/sign up expert2.d8bb1c77.png";